/**
 * Normalizes Arabic text by converting different character forms to a standard form
 * This makes searches insensitive to variations like:
 * - ة (teh marbuta) → ه (heh)
 * - أ, إ, آ, ا (different alef forms) → ا (alef)
 * - ي (yeh) and ى (alef maksura) - normalized
 * - And other variations
 */
export function normalizeArabic(text) {
  if (!text || typeof text !== 'string') {
    return text;
  }

  return text
    // Normalize different forms of Alef (ا, أ, إ, آ) to standard ا
    .replace(/[أإآ]/g, 'ا')
    // Normalize Teh Marbuta (ة) to Heh (ه)
    .replace(/ة/g, 'ه')
    // Normalize different forms of Yeh (ي) and Alef Maksura (ى) - both become ي
    .replace(/ى/g, 'ي')
    // Remove diacritics (tashkeel) for better matching
    .replace(/[\u064B-\u065F\u0670]/g, '') // Remove Arabic diacritics (fatha, damma, kasra, etc.)
    // Normalize different forms of Hamza (ؤ, ئ) to standalone hamza (ء)
    .replace(/[ؤئ]/g, 'ء')
    // Normalize different forms of Taa Marbuta variations
    // Remove zero-width characters
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    // Trim and normalize whitespace
    .trim()
    .replace(/\s+/g, ' ');
}

/**
 * Normalizes both strings and compares them
 */
export function compareArabic(str1, str2) {
  if (!str1 || !str2) return false;
  return normalizeArabic(str1) === normalizeArabic(str2);
}

